// Layout: News
// AJAX Load More functionality
document.addEventListener("DOMContentLoaded", function () {
	const section = document.querySelector("[data-news-layout]");
	if (!section) return;

	const button = section.querySelector("[data-news-load-more]");
	if (!button) return;

	const grid = section.querySelector(".news__grid");
	const spinner = button.querySelector(".news__load-more-spinner");
	const buttonText = button.querySelector(".news__load-more-text");
	const perPage = parseInt(section.dataset.perPage, 10) || 9;
	const excludeId = parseInt(section.dataset.excludeId, 10) || 0;
	let offset = parseInt(section.dataset.offset, 10) || perPage;
	let loading = false;

	button.addEventListener("click", function () {
		if (loading) return;
		loading = true;

		// Show spinner, hide text
		spinner.classList.remove("hidden");
		buttonText.classList.add("hidden");

		const formData = new FormData();
		formData.append("action", "bl_load_more_news");
		formData.append("nonce", blNews.nonce);
		formData.append("offset", offset);
		formData.append("per_page", perPage);
		formData.append("exclude_id", excludeId);

		fetch(blNews.ajax_url, {
			method: "POST",
			body: formData,
		})
			.then(function (response) {
				return response.json();
			})
			.then(function (data) {
				if (data.html) {
					grid.insertAdjacentHTML("beforeend", data.html);
					offset += perPage;
				}

				if (!data.has_more) {
					button.parentElement.remove();
				}
			})
			.catch(function (error) {
				console.error("News load more error:", error);
			})
			.finally(function () {
				loading = false;
				spinner.classList.add("hidden");
				buttonText.classList.remove("hidden");
			});
	});
});
